module.exports = "/_next/static/images/Embed@2x-a1dc931027d0502e405bf7c6cea47de7.webp";